<formly-form
    [form]="compForm"
    [fields]="fields"
    [model]="model"
    (modelChange)="onModelChanged($event)"
></formly-form>
